import React, { createContext, useContext } from "react"

import { Floor } from "shared/types/Floor"
import { Project } from "shared/types/Project"
import { SelectOption } from "shared/types/Select"
import { FormContextValue } from "shared/ui/form/FormContext"

import { ClarificationRequestModel } from "entities/clarification-requests/types/ClarificationRequestModel"

export interface RoomFormContextValue extends FormContextValue {
  clarificationRequest?: ClarificationRequestModel | null
  positionOptions?: SelectOption<number>[]
  isLoadingPositionOptions?: boolean
  projectOptions?: SelectOption<string, Project>[]
  isLoadingProjectOptions?: boolean
  floorOptions?: SelectOption<string | null, Floor>[]
  isLoadingFloorOptions?: boolean
  hideProject?: boolean
  hideClarificationRequest?: boolean
  hideAttachments?: boolean
  shouldShowHint?: boolean
  onHintClose?: () => void
}

const RoomFormContext = createContext<RoomFormContextValue | undefined>(
  undefined
)

export interface RoomFormProviderProps {
  value: RoomFormContextValue
  children: React.ReactNode
}

export const RoomFormProvider = React.memo(
  ({ value, children }: RoomFormProviderProps) => (
    <RoomFormContext.Provider value={value}>
      {children}
    </RoomFormContext.Provider>
  )
)

export function useRoomFormContext(): RoomFormContextValue {
  const context = useContext(RoomFormContext)
  if (!context) {
    throw new Error("useRoomFormContext must be used within a RoomFormProvider")
  }
  return context
}
